<div #theInput >
  <div class="input">
    @if (!color) {
      <input [ngClass]="{added: createValue, uppercase: uppercase}" type="text" placeholder="{{(placeholder ? placeholder : 'Search') | translate}}" [(ngModel)]="inputValue" class="dropdown" (click)="startDropDown()" (focus)="showOptions = true" (ngModelChange)="search()" [required]="required" [disabled]="disabled">
    }
    @if (color) {
      <!-- selected_color -->
      <input [ngClass]="{added: createValue, uppercase: uppercase}" [ngStyle]="{'width.px': theInput.offsetWidth, 'background':selected_color.color_code, 'color':selected_color.font_color}" type="text" placeholder="{{(placeholder ? placeholder : 'Search') | translate}}" [(ngModel)]="inputValue" class="dropdown" (click)="startDropDown()" (focus)="showOptions = true" (blur)="blur()" (ngModelChange)="search()" [required]="required" [disabled]="disabled">
    }
  </div>
  @if (!color) {
    @if (!multiple) {
      @if (showOptions && filteredList.length > 0) {
        <div class="options" #options [ngStyle]="{'width.px': theInput.offsetWidth }">
          <ul>
            @if (showEmpty) {
              <li (click)="clickEmpty()">{{(placeholder ? placeholder : 'Search') | translate}}</li>
            }
            @if (sliceStart > 0) {
              <li class="viewMore" (click)="moveSlice('previous', options)">{{'Previous' | translate}}</li>
            }
            @for (opt of filteredList | slice:sliceStart:sliceEnd; track useTrackBy ? trackBy(i, opt) : opt; let i = $index) {
              <li (click)="selectOption(opt); selectModel(opt)" [ngClass]="{selected: appModel == getValue(opt)}">{{getName(opt)}}</li>
            }
            @if (filteredList.length > sliceEnd) {
              <li class="viewMore" (click)="moveSlice('next', options)">{{'Next' | translate}}</li>
            }
          </ul>
        </div>
      }
    }
    @if (multiple) {
      @if (showOptions && filteredList.length > 0) {
        <div class="options" [ngClass]="{ 'pos-rel': posRelative }" #options [ngStyle]="{'width.px': theInput.offsetWidth }">
          <ul>
            @if (sliceStart > 0) {
              <li class="viewMore" (click)="moveSlice('previous', options)">{{'Previous' | translate}}</li>
            }
            @for (opt of filteredList | slice:sliceStart:sliceEnd; track useTrackBy ? trackBy(i, opt) : opt; let i = $index) {
              <li (click)="selectOption(opt)" [ngClass]="{selected: appModel == getValue(opt)}">
                <div class="checkBoxCOnt" [ngClass]="{'space': showCheckboxOptions && opt.selected}">
                  <input type="checkbox" name="{{'selected_' + i}}" [(ngModel)]="opt.selected" [disabled]="disabled">
                  <p class="checkbox" [ngClass]="{'space': showCheckboxOptions && opt.selected, 'small': showCheckboxOptions}">
                    {{getName(opt)}}
                  </p>
                  @if (showCheckboxOptions && opt.selected) {
                    <div class="line-buttons">
                      <a class="line_button" [ngClass]="{'active': !opt.isExcluded}" (click)="toggleWithoutOption($event, opt)">{{'With' | translate}}</a>
                      <a class="line_button" [ngClass]="{'active': opt.isExcluded}" (click)="toggleWithoutOption($event, opt)">{{'Without' | translate}}</a>
                    </div>
                  }
                  @if (opt.selected && showSlideToggle) {
                    <div class="line-buttons" (click)="$event.stopPropagation()">
                      <mat-slide-toggle name="{{'include_' + i}}" [checked]="getSlideCheckStatus(opt)" (change)="toggleSlideStatus($event, opt)" class="custom-slide-toggle"></mat-slide-toggle>
                    </div>
                  }
                </div>
              </li>
            }
            @if (filteredList.length > sliceEnd) {
              <li class="viewMore" (click)="moveSlice('next', options)">{{'Next' | translate}}</li>
            }
          </ul>
        </div>
      }
    }
    @if (showOptions && filteredList.length == 0) {
      <div class="options" #options [ngStyle]="{'width.px': theInput.offsetWidth }">
        <ul>
          @if (!toCreate || (toCreate && !inputValue)) {
            <li class="noHover">{{'There are no options to list' | translate}}</li>
          }
        </ul>
      </div>
    }
  }
  @if (color) {
    @if (showOptions) {
      <div class="options" #options [ngStyle]="{'width.px': theInput.offsetWidth }">
        <ul>
          @if (sliceStart > 0) {
            <li class="viewMore" (click)="moveSlice('previous', options)">{{'Previous' | translate}}</li>
          }
          @for (opt of filteredList | slice:sliceStart:sliceEnd; track opt; let i = $index) {
            <li (click)="selectOption(opt)" [ngClass]="{selected: appModel == getValue(opt)}" [ngStyle]="{'background':opt.color_code, 'color':opt.font_color}">{{getName(opt)}}</li>
          }
          @if (filteredList.length > sliceEnd) {
            <li class="viewMore" (click)="moveSlice('next', options)">{{'Next' | translate}}</li>
          }
        </ul>
      </div>
    }
  }

</div>

